import { PositionType } from '@sdk/positions/types/PositionType';

export type FormEmployee = {
  fullName: string;
  position: { id: number | null };
  email: string;
};

const DEFAULT_COUNT = 3;

export default function getDefaultEmployees(positions: PositionType[]): FormEmployee[] {
  return new Array(DEFAULT_COUNT).fill(true).map((_, i) => getEmployeeForIndex(i, positions));
}

export function getEmployeeForIndex(index: number, positions: PositionType[]): FormEmployee {
  let positionId = null;
  if (positions?.length) {
    positionId = positions[index]?.id || positions[positions.length - 1].id;
  }

  return {
    fullName: '',
    email: '',
    position: { id: positionId },
  };
}
